<template>
  <main-layout
    class="uplinkForm"
    page-title="数据上链配置"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="form-box">
        <el-form
          v-loading="loading"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="种类" prop="cropId" required v-if="addFlag">
            <el-select
              v-model="ruleForm.cropId"
              class="crop_input"
              @change="changeCrop"
              filterable
              size="medium"
              placeholder="作物、禽畜、水产"
            >
              <el-option
                v-for="item in cropList"
                :key="item.id"
                :label="item.cropName"
                :value="item.id"
              >
                <span style="float: left">{{ item.cropName }}</span>
                <span
                  style="
                    float: right;
                    color: #8492a6;
                    font-size: 13px;
                    margin-right: 20px;
                  "
                  >{{ item.cropAliasName }}</span
                >
              </el-option>
            </el-select>
            <!-- <el-button class="crop_add" @click="addTypeFn">添加</el-button> -->
            <div class="hot-search">
              <span class="hot-title">热门： </span>
              <p class="tags-cell">
                <span
                  class="tag-name"
                  v-for="item in hotCropList"
                  :key="item.id"
                  @click="selectTag(item.id)"
                  >{{ item.cropName }}</span
                >
              </p>
            </div>
          </el-form-item>
          <el-form-item label="种类" prop="cropId" required v-else>
            {{ ruleForm.cropName }}
          </el-form-item>
          <el-form-item label="地块" prop="landIds">
            <el-button
              v-if="!ruleForm.landIds.length"
              round
              size="medium"
              class="select-btn"
              @click="chooseLandHandle"
              >选择地块</el-button
            >
            <el-button
              v-else
              round
              size="medium"
              type="text"
              @click="chooseLandHandle"
            >
              {{
                `已选择${ruleForm.landIds.length}个地块(共${ruleForm.landAcre}亩)`
              }}
            </el-button>
          </el-form-item>

          <el-form-item
            label="截止时间"
            prop="endDate"
            required
            class="time-range"
          >
            <!-- <el-date-picker
              v-model="ruleForm.date[0]"
              :disabled="!addFlag"
              size="medium"
              :clearable="false"
              value-format="yyyy-MM-dd"
              placeholder="开始日期"
              style="width: 100%"
            >
            </el-date-picker>
            <span style="margin: 0 10px">至</span> -->
            <el-date-picker
              v-model="ruleForm.endDate"
              size="medium"
              :clearable="false"
              value-format="yyyy-MM-dd"
              placeholder="截止时间"
              style="width: 100%"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="上链类型" prop="uplinkType" required>
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <ul class="uplinkType-list">
              <li
                class="uplinkType-item"
                :class="{
                  selected: ruleForm.uplinkType.indexOf(item.value) !== -1,
                }"
                v-for="item in uplinkTypeArr"
                :key="item.value"
              >
                <i
                  v-if="ruleForm.uplinkType.indexOf(item.value) !== -1"
                  class="iconfont icon-round-check"
                ></i>
                {{ item.label }}
              </li>
            </ul>
            <ul class="uplinkType-list">
              <li
                class="uplinkType-item uplinkTypeDynamic"
                :class="{
                  selected: ruleForm.uplinkType.indexOf(item.value) !== -1,
                }"
                v-for="item in uplinkTypeDynamicArr"
                :key="item.value"
                @click="changeDynamicUplinkType(item)"
              >
                <i
                  v-if="ruleForm.uplinkType.indexOf(item.value) !== -1"
                  class="iconfont icon-round-check"
                ></i>
                {{ item.label }}
              </li>
            </ul>
            <ul class="uplinkType-list">
              <li
                class="uplinkType-item uplinkTypeDynamic"
                :style="{ opacity: index > 0 ? 0 : 1 }"
                :class="{
                  selected: ruleForm.uplinkType.indexOf(item.value) !== -1,
                }"
                v-for="(item, index) in storageTypeArr"
                :key="item.value"
                @click="changeStoreType(item)"
              >
                <i
                  v-if="ruleForm.uplinkType.indexOf(item.value) !== -1"
                  class="iconfont icon-round-check"
                ></i>
                {{ item.label }}
              </li>
            </ul>
            <ul class="uplinkType-list">
              <li
                class="uplinkType-item uplinkTypeDynamic"
                :class="{
                  selected: ruleForm.uplinkType.indexOf(item.value) !== -1,
                }"
                v-for="item in storageTypeArrForEgg"
                :key="item.value"
                @click="changeStoreTypeForEgg(item)"
              >
                <i
                  v-if="ruleForm.uplinkType.indexOf(item.value) !== -1"
                  class="iconfont icon-round-check"
                ></i>
                {{ item.label }}
              </li>
            </ul>
            <!-- <el-checkbox-group
              size="medium"
              v-model="ruleForm.uplinkType"
              style="width: 460px"
            >
              <el-checkbox
                v-for="item in uplinkTypeArr"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group> -->
          </el-form-item>
          <el-form-item label="是否上链" prop="status" required>
            <el-switch
              v-model="ruleForm.status"
              :active-value="0"
              :inactive-value="1"
            >
            </el-switch>
          </el-form-item>
        </el-form>
        <div class="submit-btn">
          <el-button type="primary" @click="submitForm">保 存</el-button>
        </div>
        <!-- 地块 -->
        <div class="land-shade" v-if="showLand && !closeOpen"></div>
        <div v-if="showLand && !closeOpen" class="land-content">
          <div class="land-content-list">
            <choose-land
              :selectLandLists="selectLandLists"
              @submit="chooseLandFun"
              @selectLandList="selectLandList"
            ></choose-land>
          </div>
          <button class="close-btn" @click="closeHandle">
            <img src="@/assets/images/common/bg-close.png" alt="" />
          </button>
        </div>
      </div>
      <AddType
        :showFlag.sync="showAddTypeFlag"
        @update:showFlag="(val) => (showAddTypeFlag = val)"
        @updateCropList="updateCropList"
      />
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import ChooseLand from "./ChooseLand/Index.vue";
import AddType from "./components/AddType";
import { Switch } from "element-ui";
import { mapState, mapGetters } from "vuex";
import { getStorage } from "@/utils/storage";
import { formatDate } from "@/utils";
import {
  cropService,
  addDataUplink,
  getDataUplinkDetail,
} from "@/api/request/snkd.produce";

export default {
  name: "UplinkForm",
  components: {
    MainLayout,
    ChooseLand,
    AddType,
    ElSwitch: Switch,
  },
  data() {
    return {
      addFlag: true, //判断是编辑还是新增
      checkAll: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      loading: false,
      showAddTypeFlag: false, //添加员工弹窗
      showLand: false,
      selectLandLists: [],
      hotCropList: [],
      cropList: [],
      curId: "",
      curUplinkDynamicType: [],
      ruleForm: {
        landIds: [],
        landAcre: "",
        cropId: "",
        endDate: "",
        uplinkType: [],
        status: 1,
        imgUrl: "",
        cropName: "",
      },
      startDate: null,
      info: getStorage("FARMINFO"),
      rules: {
        landIds: [{ required: true, message: "请选择地块", trigger: "blur" }],
        cropId: [{ required: true, message: "请选择种类", trigger: "change" }],
        endDate: [
          {
            required: true,
            message: "请选择截止时间",
            trigger: "change",
          },
        ],
        uplinkType: [
          { required: true, message: "请选择上链种类信息", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择是否上链", trigger: "change" },
        ],
      },
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      uplinkTypeArr: [
        {
          label: "采收信息",
          value: 1,
        },
        {
          label: "合格证信息",
          value: 2,
        },
        {
          label: "生产档案",
          value: 3,
        },
        {
          label: "销售信息",
          value: 4,
        },
        {
          label: "农事信息",
          value: 5,
        },
        {
          label: "种源信息",
          value: 6,
        },
      ],
      uplinkTypeDynamicArr: [
        {
          label: "获奖证书",
          value: 7,
        },
      ],
      storageTypeArr: [
        {
          label: "仓储加工检测（水稻）",
          value: 8,
        },
        {
          label: "加工信息",
          value: 9,
        },
        {
          label: "检测信息",
          value: 10,
        },
      ],
      storageTypeArrForEgg: [
        {
          label: "加工检测（鸡蛋）",
          value: 11,
        },
      ],
    };
  },
  mounted() {
    this.addFlag = this.$route.query.id ? false : true;
    if (this.addFlag) {
      //新增
      this.getHotCropGroup();
      this.getCropList();
    } else {
      // 编辑
      this.ruleForm.cropId = this.$route.query.cropId;
      this.getDataUplinkDetail();
    }
  },
  computed: {
    ...mapState("uplink", {
      closeOpen: "closeOpen",
    }),
    ...mapGetters("uplink", ["hadSelectedLandList", "showLandList"]),
    //求和
    totalAcre() {
      return this.calcLandAcre(this.selectLandLists);
    },
  },
  methods: {
    handleCheckAllChange(val) {
      this.ruleForm.uplinkType = val
        ? this.uplinkTypeArr.map((item) => item.value)
        : [];
      this.checkAll = val;
      let uplinkTypeDynamicArr = val
        ? this.uplinkTypeDynamicArr.map((item) => item.value)
        : [];
      let storageTypeArr = val
        ? this.storageTypeArr.map((item) => item.value)
        : [];
      let storageTypeArrForEgg = val
        ? this.storageTypeArrForEgg.map((item) => item.value)
        : [];
      this.ruleForm.uplinkType = [
        ...this.ruleForm.uplinkType,
        ...uplinkTypeDynamicArr,
        ...storageTypeArrForEgg,
        ...storageTypeArr,
      ];
    },
    changeDynamicUplinkType(data) {
      let index = this.ruleForm.uplinkType.indexOf(data.value);
      let len =
        this.uplinkTypeArr.length +
        this.uplinkTypeDynamicArr.length +
        this.storageTypeArrForEgg.length +
        this.storageTypeArr.length;
      if (index !== -1) {
        this.ruleForm.uplinkType.splice(index, 1);
      } else {
        this.ruleForm.uplinkType.push(data.value);
      }
      if (this.ruleForm.uplinkType.length === len) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.$refs.ruleForm.validateField("uplinkType");
    },
    changeStoreType({ value }) {
      if (this.ruleForm.uplinkType.includes(value)) {
        this.ruleForm.uplinkType = this.ruleForm.uplinkType.filter((item) => {
          return !this.storageTypeArr.map((item) => item.value).includes(item);
        });
      } else {
        this.ruleForm.uplinkType.push(
          ...this.storageTypeArr.map((item) => item.value)
        );
      }
      let len =
        this.uplinkTypeArr.length +
        this.uplinkTypeDynamicArr.length +
        this.storageTypeArrForEgg.length +
        this.storageTypeArr.length;
      if (this.ruleForm.uplinkType.length === len) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.$refs.ruleForm.validateField("uplinkType");
    },
    changeStoreTypeForEgg({ value }) {
      if (this.ruleForm.uplinkType.includes(value)) {
        this.ruleForm.uplinkType = this.ruleForm.uplinkType.filter((item) => {
          return !this.storageTypeArrForEgg
            .map((item) => item.value)
            .includes(item);
        });
      } else {
        this.ruleForm.uplinkType.push(
          ...this.storageTypeArrForEgg.map((item) => item.value)
        );
      }
      let len =
        this.uplinkTypeArr.length +
        this.uplinkTypeDynamicArr.length +
        this.storageTypeArrForEgg.length +
        this.storageTypeArr.length;
      if (this.ruleForm.uplinkType.length === len) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.$refs.ruleForm.validateField("uplinkType");
    },
    updateCropList() {
      this.getHotCropGroup();
      this.getCropList();
    },
    //打开新增种类弹窗
    addTypeFn() {
      this.showAddTypeFlag = true;
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log("校验通过");
          const h = this.$createElement;
          this.$confirm("", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "confirm-dialog",
            message: h("div", [
              h(
                "p",
                {
                  style:
                    "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
                },
                `是否确认勾选范围的数据上链？`
              ),
              h(
                "p",
                {
                  style:
                    "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
                },
                [h("span", null, "温馨提示：当日录入的数据24:00以后不可修改。")]
              ),
            ]),
            iconClass: "el-icon-warning",
          })
            .then(async () => {
              this.saveForm();
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async saveForm() {
      const { companyId, farmId } = this.info;
      let params = {
        companyId: companyId,
        cropId: this.ruleForm.cropId,
        endDate: this.ruleForm.endDate,
        farmId: farmId,
        landIds: this.ruleForm.landIds.join(","),
        // startDate: this.ruleForm.date[0],
        uploadTypes: this.ruleForm.uplinkType.join(","),
        status: this.ruleForm.status,
        imgUrl: this.ruleForm.imgUrl,
        cropName: this.ruleForm.cropName,
      };
      if (this.curId) {
        params = Object.assign(params, { id: this.curId });
      }
      try {
        await addDataUplink(params).then((res) => {
          const { respCode } = res;
          if (respCode === 0) {
            this.$message({
              message: "填报成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getDataUplinkDetail() {
      this.loading = true;
      try {
        await getDataUplinkDetail({
          id: this.$route.query.id,
        }).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            if (!obj) {
              //未添加
              this.loading = false;
              return false;
            }
            //已添加
            this.curId = obj.id;
            this.ruleForm.landIds = obj.landIds
              .split(",")
              .map((item) => item * 1);
            this.ruleForm.status = obj.status;
            this.ruleForm.cropId = obj.cropId;
            this.ruleForm.cropName = obj.cropName;
            this.ruleForm.imgUrl = obj.imgUrl;
            this.selectLandLists = obj.landList;
            this.ruleForm.landAcre = this.calcLandAcre(this.selectLandLists);
            this.ruleForm.endDate = formatDate(obj.endDate, "yyyy-MM-dd");
            this.startDate = obj.startDate;
            this.ruleForm.uplinkType = obj.uploadTypes
              .split(",")
              .map((item) => item * 1);
            let len =
              this.uplinkTypeArr.length +
              this.uplinkTypeDynamicArr.length +
              this.storageTypeArrForEgg.length +
              this.storageTypeArr.length;
            if (this.ruleForm.uplinkType.length === len) {
              this.checkAll = true;
            } else {
              this.checkAll = false;
            }
            this.loading = false;
          }
        });
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    selectTag(cropId) {
      this.ruleForm.cropId = cropId;
      this.$refs.ruleForm.validateField("cropId");
    },
    // 获取热门作物
    async getHotCropGroup() {
      try {
        const { hotList } = await cropService.getListByLayered();
        const hot = hotList.list.filter(
          (item) => !this.$route.query.cropIds.includes(item.id)
        );
        this.hotCropList = hot.slice(0, 8);
      } catch (error) {
        console.log(error);
      }
    },
    async getCropList() {
      const { companyId } = this.info;
      const selectCrop = this.$route.query.cropIds;
      try {
        const { list } = await cropService.listAllShort({ companyId });
        const result = list.filter((item) => !selectCrop.includes(item.id));
        this.cropList = result;
      } catch (error) {
        console.log(error);
      }
    },
    //打开地块弹框
    chooseLandHandle() {
      this.$store.commit("uplink/closeLand", false);
      this.$store.commit("uplink/changeShowLandMode", "ListMode");
      this.showLand = true;
    },
    //关闭地块弹框
    closeHandle() {
      this.showLand = false;
      this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
      this.ruleForm.landAcre = this.totalAcre;
      //清空筛选条件
      this.$store.commit("uplink/clearPageAllStatus");
    },
    // 地块选择确定
    chooseLandFun() {
      this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
      this.ruleForm.landAcre = this.totalAcre;
      this.$refs.ruleForm.validateField("landIds");
    },
    selectLandList(evt) {
      this.selectLandLists = evt;
    },
    //求和
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => {
          if (cur.statisticsLandAcre) {
            return total + cur.statisticsLandAcre;
          } else {
            return total + cur.landAcre;
          }
        }, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    // 返回上一页
    goBack() {
      window.history.go(-1);
    },
    //选择作物
    changeCrop(id) {
      const item = this.cropList.find((i) => i.id === id);
      if (item) {
        this.ruleForm.cropName = item.cropName;
        this.ruleForm.imgUrl = item.imgUrl;
      } else {
        this.ruleForm.cropName = "";
      }
    },
    // 禁用日期逻辑
    disabledDate(date) {
      if (!this.ruleForm.endDate) return false; // 如果接口未返回时间，则不限制
      return date.getTime() < this.startDate; // 只允许选择 time 之前的日期
    },
  },
};
</script>

<style scoped lang="scss">
.uplinkForm {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;

    .form-box {
      background: #fff;
      height: 100%;

      ::v-deep .demo-ruleForm {
        padding: 40px;
        width: 560px;
        margin: 0 auto;

        .form-txt {
          color: #c0c4cc;
        }

        .select-btn {
          border: 1px solid #64c3a4;
          color: #64c3a4;
        }

        .crop_input {
          width: 360px !important;
          height: auto;
        }

        .crop_add {
          margin-left: 10px;
        }

        .hot-search {
          width: 440px;
          margin-top: 10px;
          display: flex;

          .hot-title {
            flex-shrink: 0;
            color: #333333;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
          }

          .tags-cell {
            display: inline-block;
            line-height: 20px;

            .tag-name {
              color: #64c3a4;
              font-size: 14px;
              margin: 0 5px;
              cursor: pointer;
            }
          }
        }

        .uplinkType-list {
          width: 700px;
          display: flex;
          flex-wrap: wrap;

          .uplinkType-item {
            margin-right: 20px;
            height: 38px;
            line-height: 38px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #606266;

            .iconfont {
              color: #ffffff;
              font-size: 14px;
            }

            &.selected {
              color: $--color-primary;

              .iconfont {
                color: $--color-primary;
              }
            }
          }

          .uplinkTypeDynamic {
            cursor: pointer;
          }
        }
      }

      .submit-btn {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 100px;
        text-align: center;
        padding-top: 20px;

        .el-button {
          width: 160px;
          height: 38px;
        }
      }

      .land-shade {
        width: 100%;
        height: 100%;
        background-color: rgb(0, 0, 0);
        opacity: 0.3;
        z-index: 5;
        position: absolute;
        top: 0px;
        left: 0;
      }

      .land-content {
        position: absolute;
        top: 13%;
        left: 0;
        right: 0;
        width: 1200px;
        height: 85%;
        z-index: 10;
        margin: 0 auto;

        .land-content-list {
          width: 100%;
          height: 95%;
          background-color: #fff;
          margin: 0 auto;
          border-radius: 10px;
          padding: 10px;
          position: relative;
        }

        .close-btn {
          position: absolute;
          right: -5%;
          top: 0;
          height: 36px;
          width: 36px;
          border: 2px solid #fff;
          border-radius: 50%;
          outline: 0;
          background-color: rgb(0, 0, 0);
          opacity: 0.2;
          cursor: pointer;

          img {
            vertical-align: middle;
          }
        }
      }

      .land-select {
        font-size: 14px;
        font-weight: 400;
        color: #64c3a4;
        cursor: pointer;
      }
    }
  }
  ::v-deep .el-date-editor--date {
    width: 50% !important;
  }
  .time-range {
    ::v-deep .el-form-item__content {
      display: flex;
    }
  }
}

.desc_input {
  width: 20%;
}
</style>
<style>
.el-message-box__status.el-icon-warning {
  color: red;
}

.el-select-dropdown {
  width: 300px !important;
}

.el-select__tags-text {
  max-width: 90px;
}

.el-select__tags {
  flex-wrap: wrap !important;
  overflow: hidden;
}
</style>
